export const APP_STORE = {
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.grilld.grilld&hl=en_AU',
  APPLE_STORE: 'https://apps.apple.com/au/app/grilld/id1228060909'
}

export const GRILLD_URL = 'https://grilld.com.au'

export const GRILLD_TERMS_GIFT_CARD = 'https://grilld.com.au/legal-information/grilld-gift-card-terms-conditions'
